<script setup lang="ts">
import { type Component, computed } from "vue";

import { Button } from "@/components/global";
import { ButtonRounded, ButtonSize, ButtonVariant } from "./Button.vue";

interface Props {
  data?: unknown[] | null;
  loading?: boolean;
  message?: string;
  buttonText?: string;
  buttonIcon?: Component | string | null;
  buttonVariant?: ButtonVariant;
  buttonRounded?: ButtonRounded;
  buttonSize?: ButtonSize;
  buttonTestId?: string;
  iconComponent?: Component | string | null;
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  message: "No data available",
  buttonVariant: "default",
  buttonRounded: "lg",
  buttonSize: "sm",
  buttonTestId: "empty-state-btn",
});

const emit = defineEmits<(e: "click") => void>();

const show = computed(
  () =>
    (!props.data && !props.loading) ||
    ((props.data as unknown[] | null)?.length === 0 && !props.loading)
);

const onClick = () => {
  emit("click");
};
</script>

<template>
  <div
    v-if="show"
    class="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
  >
    <div v-if="iconComponent" style="margin-bottom: 0.25rem">
      <component :is="iconComponent" />
    </div>
    <span
      style="margin-bottom: 1rem; font-size: 1.125rem;"
      class="text-black text-center"
    >
      {{ message }}
    </span>

    <div v-if="buttonText" style="width: 100%; max-width: 9rem; margin: 0 auto;">
      <Button
        :variant="buttonVariant"
        :rounded="buttonRounded"
        :size="buttonSize"
        :testId="buttonTestId"
        @click="onClick"
      >
        <span class="flex-center">
          <component
            v-if="buttonIcon"
            :is="buttonIcon"
            width="10"
            height="10"
            style="margin-right: 0.25rem"
          />
          {{ buttonText }}
        </span>
      </Button>
    </div>
  </div>
</template>
